import React, { Fragment } from 'react'

import ReferralESignatureConsentPdf from '@/components/misc/ReferralESignatureConsentPdf/ReferralESignatureConsentPdf'
import { DATE_FORMATS } from '@/lib/constants'
import { formatDate } from '@/lib/helpers/dateHelpers'

interface Props {
  referral: React.ComponentProps<
    typeof ReferralESignatureConsentPdf
  >['referral']
}

const AddressBlock: React.FC<Props> = ({ referral }) => {
  const fromCompany = referral.fromCompany
  const address = fromCompany.mainAddress

  const lines: string[] = [
    address?.street,
    address?.city,
    address?.county,
    address?.postcode,
  ].filter((line): line is string => !!line && !!line.trim())

  return (
    <div className="text-right" style={{ maxWidth: '320px' }}>
      {fromCompany.presentationName}
      <br />

      {lines.map((line, index) => (
        <Fragment key={index}>
          {line.trim()}
          <br />
        </Fragment>
      ))}

      <div className="mt-4">
        {formatDate(referral.referralDate, DATE_FORMATS.DAY_MONTH_YEAR)}
      </div>
    </div>
  )
}

export default AddressBlock
